// extracted by mini-css-extract-plugin
export default {"mobile":"768px"};